export const CONST_ACKNOWLEDGE_WALLET_RISK = 'ackWalletRisk';
